import * as THREE from "three";
import { itemDef } from "./items";
import type { Inventory } from "./inventory";

interface Drop {
  id: number;
  count: number;
  mesh: THREE.Mesh;
  age: number;
}

export class ItemDrops {
  readonly group = new THREE.Group();
  private items: Drop[] = [];
  private geo = new THREE.BoxGeometry(0.28, 0.28, 0.28);

  spawn(x: number, y: number, z: number, id: number, count = 1): void {
    const c = itemDef(id).color;
    const color = (c[0] << 16) | (c[1] << 8) | c[2];
    const mesh = new THREE.Mesh(this.geo, new THREE.MeshLambertMaterial({ color }));
    mesh.position.set(x, y, z);
    this.group.add(mesh);
    this.items.push({ id, count, mesh, age: 0 });
  }

  update(dt: number, px: number, py: number, pz: number, inv: Inventory): void {
    for (let i = this.items.length - 1; i >= 0; i--) {
      const d = this.items[i]!;
      d.age += dt;
      d.mesh.rotation.y += dt * 2.2;
      d.mesh.position.y += Math.sin(d.age * 3) * 0.004;
      const dx = px - d.mesh.position.x;
      const dy = py + 0.8 - d.mesh.position.y;
      const dz = pz - d.mesh.position.z;
      const dist = Math.hypot(dx, dy, dz);
      if (d.age > 0.4 && dist < 1.6) {
        const left = inv.add(d.id, d.count);
        if (left <= 0) {
          this.group.remove(d.mesh);
          (d.mesh.material as THREE.Material).dispose();
          this.items.splice(i, 1);
        }
      } else if (d.age > 90) {
        this.group.remove(d.mesh);
        this.items.splice(i, 1);
      }
    }
  }
}
